/**
 * @generated SignedSource<<6043ace72603a954fb923b2849019d99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeasurementRecordItem_measurementRecord$data = {
  readonly id: string;
  readonly createdAt: any;
  readonly author: {
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
  };
  readonly measurement: {
    readonly id: string;
    readonly value: string;
    readonly template: {
      readonly id: string;
      readonly name: string;
    };
  };
  readonly " $fragmentType": "MeasurementRecordItem_measurementRecord";
};
export type MeasurementRecordItem_measurementRecord = MeasurementRecordItem_measurementRecord$data;
export type MeasurementRecordItem_measurementRecord$key = {
  readonly " $data"?: MeasurementRecordItem_measurementRecord$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeasurementRecordItem_measurementRecord">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeasurementRecordItem_measurementRecord",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OrganizationUser",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Measurement",
      "kind": "LinkedField",
      "name": "measurement",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeasurementTemplate",
          "kind": "LinkedField",
          "name": "template",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MeasurementRecord",
  "abstractKey": null
};
})();

(node as any).hash = "483fd41ba99a71af3ed342ccbc8fc780";

export default node;
